export enum MatColor {
  basic = 'basic',
  primary = 'primary',
  warn = 'warn',
  accent = 'accent',
}
